import React from 'react';
import { useLanguageStore } from '../store';

export default function PrivacyPolicyPage() {
  const language = useLanguageStore((state) => state.language);

  if (language === 'en') {
    return (
      <div className="max-w-4xl mx-auto px-4 py-12">
        <div className="bg-white dark:bg-gray-800 rounded-xl shadow-md p-8 md:p-12">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-2">
            Privacy Policy
          </h1>
          <p className="text-sm text-gray-500 dark:text-gray-400 mb-8">
            Online store iglakmierzejewski.pl
          </p>
          <p className="text-sm text-gray-500 dark:text-gray-400 mb-10 border-b border-gray-200 dark:border-gray-700 pb-6">
            Effective as of January 1, 2025
          </p>

          <div className="space-y-10 text-gray-700 dark:text-gray-300 leading-relaxed">
            <section>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
                <span className="text-green-600 dark:text-green-400 font-bold mr-3">§1</span>
                Data Controller
              </h2>
              <ol className="list-decimal list-outside ml-6 space-y-3">
                <li>
                  The controller of personal data collected through the online store operating at iglakmierzejewski.pl is MERCATUS IT Michał Mierzejewski, Białogórne 5, 96-230 Białogórne, NIP: 8351621513, REGON: 541142920 (hereinafter referred to as the "Controller").
                </li>
                <li>
                  Contact with the Controller regarding personal data matters is possible via email at: iglakmierz@gmail.com.
                </li>
                <li>
                  The Controller processes personal data in accordance with GDPR and applicable provisions of Polish law.
                </li>
              </ol>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
                <span className="text-green-600 dark:text-green-400 font-bold mr-3">§2</span>
                Scope of Collected Data
              </h2>
              <ol className="list-decimal list-outside ml-6 space-y-3">
                <li>
                  The Controller may process the following personal data of the User:
                  <ul className="list-disc list-outside ml-6 mt-2 space-y-1">
                    <li>full name,</li>
                    <li>delivery address,</li>
                    <li>email address,</li>
                    <li>telephone number,</li>
                    <li>invoice data, including company name, address, and VAT number, if invoice issuance is required or requested,</li>
                    <li>data provided in correspondence directed to the Controller.</li>
                  </ul>
                </li>
                <li>
                  Providing data is voluntary, but necessary to place an Order, fulfill the agreement, or make contact.
                </li>
              </ol>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
                <span className="text-green-600 dark:text-green-400 font-bold mr-3">§3</span>
                Purposes and Legal Bases for Processing
              </h2>
              <ol className="list-decimal list-outside ml-6 space-y-3">
                <li>
                  Personal data are processed for the following purposes:
                  <ul className="list-disc list-outside ml-6 mt-2 space-y-1">
                    <li>
                      <strong className="text-gray-900 dark:text-white">Conclusion and performance of agreement</strong> — legal basis: Article 6(1)(b) GDPR;
                    </li>
                    <li>
                      <strong className="text-gray-900 dark:text-white">Payment processing</strong> — legal basis: Article 6(1)(b) GDPR;
                    </li>
                    <li>
                      <strong className="text-gray-900 dark:text-white">Tax and accounting obligations</strong> — legal basis: Article 6(1)(c) GDPR;
                    </li>
                    <li>
                      <strong className="text-gray-900 dark:text-white">Complaint handling and defense against claims</strong> — legal basis: Article 6(1)(c) or (f) GDPR;
                    </li>
                    <li>
                      <strong className="text-gray-900 dark:text-white">Contact with the User</strong> — legal basis: Article 6(1)(b) or (f) GDPR;
                    </li>
                    <li>
                      <strong className="text-gray-900 dark:text-white">Website analytics</strong> — if applicable, based on Article 6(1)(a) or (f) GDPR depending on technology type.
                    </li>
                  </ul>
                </li>
              </ol>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
                <span className="text-green-600 dark:text-green-400 font-bold mr-3">§4</span>
                Recipients of Personal Data
              </h2>
              <ol className="list-decimal list-outside ml-6 space-y-3">
                <li>
                  Personal data may be transferred to entities cooperating with the Controller only to the extent necessary for the processing purposes, in particular:
                  <ul className="list-disc list-outside ml-6 mt-2 space-y-1">
                    <li>payment operators, including Stripe,</li>
                    <li>courier and transport companies,</li>
                    <li>hosting and IT service providers,</li>
                    <li>accounting firms,</li>
                    <li>analytics or marketing tools providers, if used in accordance with law,</li>
                    <li>law firms or entities supporting claims,</li>
                    <li>public authorities, if the disclosure obligation arises from law.</li>
                  </ul>
                </li>
                <li>
                  The Controller does not sell User personal data.
                </li>
              </ol>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
                <span className="text-green-600 dark:text-green-400 font-bold mr-3">§5</span>
                Transfer of Data Outside the EEA
              </h2>
              <ol className="list-decimal list-outside ml-6 space-y-3">
                <li>
                  In connection with using services of certain providers, in particular Stripe or analytics tools, data may be transferred outside the European Economic Area.
                </li>
                <li>
                  In such cases, the Controller applies appropriate safeguards required by GDPR, including standard contractual clauses approved by the European Commission.
                </li>
              </ol>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
                <span className="text-green-600 dark:text-green-400 font-bold mr-3">§6</span>
                Data Retention Period
              </h2>
              <ol className="list-decimal list-outside ml-6 space-y-3">
                <li>
                  Data related to agreement fulfillment and accounting documentation are retained for the period required by law, in particular tax and accounting regulations.
                </li>
                <li>
                  Data processed on the basis of the Controller's legitimate interest are retained until an effective objection is raised or the processing purpose ceases.
                </li>
                <li>
                  Data processed on the basis of consent are retained until it is withdrawn.
                </li>
                <li>
                  Data related to complaints and claims may be retained for the period necessary for their handling and the statute of limitations.
                </li>
              </ol>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
                <span className="text-green-600 dark:text-green-400 font-bold mr-3">§7</span>
                Rights of the Data Subject
              </h2>
              <ol className="list-decimal list-outside ml-6 space-y-3">
                <li>
                  The User has the right to:
                  <ul className="list-disc list-outside ml-6 mt-2 space-y-1">
                    <li>access their data,</li>
                    <li>rectification of data,</li>
                    <li>erasure of data,</li>
                    <li>restriction of processing,</li>
                    <li>data portability,</li>
                    <li>object to processing,</li>
                    <li>withdraw consent at any time, if processing was based on consent,</li>
                    <li>lodge a complaint with the President of the Personal Data Protection Office.</li>
                  </ul>
                </li>
              </ol>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
                <span className="text-green-600 dark:text-green-400 font-bold mr-3">§8</span>
                Cookies
              </h2>
              <ol className="list-decimal list-outside ml-6 space-y-3">
                <li>
                  The Store uses cookies and similar technologies.
                </li>
                <li>
                  Cookies may be used for: proper functioning of the Store, maintaining user sessions and the shopping cart, remembering settings and preferences, payment processing, statistical analyses if the User has given consent.
                </li>
                <li>
                  Essential cookies may be used without separate consent if necessary for the proper functioning of the website.
                </li>
                <li>
                  The User may manage cookie settings through the cookie banner or browser settings.
                </li>
              </ol>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
                <span className="text-green-600 dark:text-green-400 font-bold mr-3">§9</span>
                Data Security
              </h2>
              <ol className="list-decimal list-outside ml-6 space-y-3">
                <li>
                  The Controller applies appropriate technical and organizational measures to protect personal data from loss, destruction, unauthorized disclosure, or access.
                </li>
                <li>
                  The Store uses SSL/TLS connection encryption.
                </li>
                <li>
                  Payment data are handled by an external payment operator. The Controller does not store full payment card data on its own servers.
                </li>
              </ol>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
                <span className="text-green-600 dark:text-green-400 font-bold mr-3">§10</span>
                Changes to the Privacy Policy
              </h2>
              <ol className="list-decimal list-outside ml-6 space-y-3">
                <li>
                  The Controller may amend this Privacy Policy, in particular in case of changes in law, technology, or the manner of operation of the Store.
                </li>
                <li>
                  The current version of the Privacy Policy is always available on the Store's website.
                </li>
              </ol>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
                <span className="text-green-600 dark:text-green-400 font-bold mr-3">§11</span>
                Final Provisions
              </h2>
              <ol className="list-decimal list-outside ml-6 space-y-3">
                <li>
                  In matters not regulated by this Privacy Policy, GDPR and applicable provisions of Polish law shall apply.
                </li>
                <li>
                  This Privacy Policy is effective as of January 1, 2025.
                </li>
              </ol>
            </section>
          </div>

          <div className="mt-12 pt-8 border-t border-gray-200 dark:border-gray-700">
            <div className="text-sm text-gray-500 dark:text-gray-400 space-y-1">
              <p className="font-semibold text-gray-700 dark:text-gray-300">MERCATUS IT Michał Mierzejewski</p>
              <p>Białogórne 5, 96-230 Białogórne</p>
              <p>NIP: 8351621513</p>
              <p>Email: iglakmierz@gmail.com</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-md p-8 md:p-12">
        <h1 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-2">
          Polityka Prywatności
        </h1>
        <p className="text-sm text-gray-500 dark:text-gray-400 mb-8">
          Sklep internetowy iglakmierzejewski.pl
        </p>
        <p className="text-sm text-gray-500 dark:text-gray-400 mb-10 border-b border-gray-200 dark:border-gray-700 pb-6">
          Obowiązuje od dnia 1 stycznia 2025 r.
        </p>

        <div className="space-y-10 text-gray-700 dark:text-gray-300 leading-relaxed">
          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
              <span className="text-green-600 dark:text-green-400 font-bold mr-3">§1</span>
              Administrator danych osobowych
            </h2>
            <ol className="list-decimal list-outside ml-6 space-y-3">
              <li>
                Administratorem danych osobowych zbieranych za pośrednictwem sklepu internetowego iglakmierzejewski.pl jest MERCATUS IT Michał Mierzejewski, Białogórne 5, 96-230 Białogórne, NIP: 8351621513, REGON: 541142920, dalej jako „Administrator".
              </li>
              <li>
                Kontakt z Administratorem w sprawach związanych z ochroną danych osobowych możliwy jest pod adresem e-mail: iglakmierz@gmail.com.
              </li>
              <li>
                Administrator przetwarza dane osobowe zgodnie z RODO oraz obowiązującymi przepisami prawa polskiego.
              </li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
              <span className="text-green-600 dark:text-green-400 font-bold mr-3">§2</span>
              Zakres przetwarzanych danych
            </h2>
            <ol className="list-decimal list-outside ml-6 space-y-3">
              <li>
                Administrator może przetwarzać następujące dane osobowe Użytkownika:
                <ul className="list-disc list-outside ml-6 mt-2 space-y-1">
                  <li>imię i nazwisko,</li>
                  <li>adres dostawy,</li>
                  <li>adres e-mail,</li>
                  <li>numer telefonu,</li>
                  <li>dane do faktury, w tym nazwę firmy, adres i NIP, jeżeli wystawienie faktury jest wymagane lub żądane,</li>
                  <li>dane podane w korespondencji kierowanej do Administratora.</li>
                </ul>
              </li>
              <li>
                Podanie danych jest dobrowolne, ale niezbędne do złożenia Zamówienia, realizacji umowy albo kontaktu.
              </li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
              <span className="text-green-600 dark:text-green-400 font-bold mr-3">§3</span>
              Cele i podstawy prawne przetwarzania
            </h2>
            <ol className="list-decimal list-outside ml-6 space-y-3">
              <li>
                Dane osobowe są przetwarzane w następujących celach:
                <ul className="list-disc list-outside ml-6 mt-2 space-y-1">
                  <li>
                    <strong className="text-gray-900 dark:text-white">Zawarcie i wykonanie umowy</strong> — na podstawie art. 6 ust. 1 lit. b RODO,
                  </li>
                  <li>
                    <strong className="text-gray-900 dark:text-white">Obsługa płatności</strong> — na podstawie art. 6 ust. 1 lit. b RODO,
                  </li>
                  <li>
                    <strong className="text-gray-900 dark:text-white">Realizacja obowiązków podatkowych i księgowych</strong> — na podstawie art. 6 ust. 1 lit. c RODO,
                  </li>
                  <li>
                    <strong className="text-gray-900 dark:text-white">Obsługa reklamacji, roszczeń i obrona przed roszczeniami</strong> — na podstawie art. 6 ust. 1 lit. c lub f RODO,
                  </li>
                  <li>
                    <strong className="text-gray-900 dark:text-white">Kontakt z Użytkownikiem</strong> — na podstawie art. 6 ust. 1 lit. b lub f RODO,
                  </li>
                  <li>
                    <strong className="text-gray-900 dark:text-white">Prowadzenie statystyk i analityki strony internetowej</strong> — o ile takie narzędzia są stosowane zgodnie z obowiązującymi przepisami, na podstawie art. 6 ust. 1 lit. a lub f RODO.
                  </li>
                </ul>
              </li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
              <span className="text-green-600 dark:text-green-400 font-bold mr-3">§4</span>
              Odbiorcy danych
            </h2>
            <ol className="list-decimal list-outside ml-6 space-y-3">
              <li>
                Dane osobowe mogą być przekazywane podmiotom współpracującym z Administratorem wyłącznie w zakresie niezbędnym do realizacji celów przetwarzania, w szczególności:
                <ul className="list-disc list-outside ml-6 mt-2 space-y-1">
                  <li>operatorom płatności, w tym Stripe,</li>
                  <li>firmom kurierskim i transportowym,</li>
                  <li>dostawcom hostingu i usług IT,</li>
                  <li>biuru rachunkowemu lub podmiotom świadczącym obsługę księgową,</li>
                  <li>dostawcom narzędzi analitycznych lub marketingowych, jeżeli są wykorzystywane zgodnie z prawem,</li>
                  <li>kancelariom prawnym lub podmiotom wspierającym dochodzenie roszczeń,</li>
                  <li>organom publicznym, jeżeli obowiązek udostępnienia wynika z przepisów prawa.</li>
                </ul>
              </li>
              <li>
                Administrator nie sprzedaje danych osobowych Użytkowników.
              </li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
              <span className="text-green-600 dark:text-green-400 font-bold mr-3">§5</span>
              Przekazywanie danych poza Europejski Obszar Gospodarczy
            </h2>
            <ol className="list-decimal list-outside ml-6 space-y-3">
              <li>
                W związku z korzystaniem z usług niektórych dostawców, w szczególności Stripe lub narzędzi analitycznych, dane mogą być przekazywane poza Europejski Obszar Gospodarczy.
              </li>
              <li>
                W takim przypadku Administrator stosuje odpowiednie zabezpieczenia wymagane przez RODO, w szczególności standardowe klauzule umowne zatwierdzone przez Komisję Europejską lub inne zgodne z prawem mechanizmy transferu.
              </li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
              <span className="text-green-600 dark:text-green-400 font-bold mr-3">§6</span>
              Okres przechowywania danych
            </h2>
            <ol className="list-decimal list-outside ml-6 space-y-3">
              <li>
                Dane związane z realizacją umowy i dokumentacją księgową przechowywane są przez okres wymagany przez przepisy prawa, w szczególności podatkowe i rachunkowe.
              </li>
              <li>
                Dane przetwarzane na podstawie uzasadnionego interesu Administratora przechowywane są do czasu wniesienia skutecznego sprzeciwu albo ustania celu przetwarzania.
              </li>
              <li>
                Dane przetwarzane na podstawie zgody przechowywane są do czasu jej cofnięcia.
              </li>
              <li>
                Dane związane z reklamacjami i roszczeniami mogą być przechowywane przez okres niezbędny do ich obsługi oraz przedawnienia roszczeń.
              </li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
              <span className="text-green-600 dark:text-green-400 font-bold mr-3">§7</span>
              Prawa osoby, której dane dotyczą
            </h2>
            <ol className="list-decimal list-outside ml-6 space-y-3">
              <li>
                Użytkownikowi przysługuje prawo do:
                <ul className="list-disc list-outside ml-6 mt-2 space-y-1">
                  <li>dostępu do danych,</li>
                  <li>sprostowania danych,</li>
                  <li>usunięcia danych,</li>
                  <li>ograniczenia przetwarzania,</li>
                  <li>przenoszenia danych,</li>
                  <li>wniesienia sprzeciwu wobec przetwarzania danych,</li>
                  <li>cofnięcia zgody w dowolnym momencie, jeśli podstawą przetwarzania była zgoda,</li>
                  <li>wniesienia skargi do Prezesa Urzędu Ochrony Danych Osobowych.</li>
                </ul>
              </li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
              <span className="text-green-600 dark:text-green-400 font-bold mr-3">§8</span>
              Pliki cookies
            </h2>
            <ol className="list-decimal list-outside ml-6 space-y-3">
              <li>
                Sklep wykorzystuje pliki cookies oraz podobne technologie.
              </li>
              <li>
                Cookies mogą być wykorzystywane w celu: zapewnienia prawidłowego działania Sklepu, utrzymania sesji użytkownika i obsługi koszyka, zapamiętywania ustawień i preferencji, obsługi płatności, prowadzenia analiz statystycznych i analitycznych, jeżeli Użytkownik wyrazi na to wymaganą zgodę.
              </li>
              <li>
                Niezbędne pliki cookies mogą być stosowane bez odrębnej zgody, jeżeli są konieczne do prawidłowego działania strony.
              </li>
              <li>
                Analityczne lub inne nieniezbędne pliki cookies są wykorzystywane wyłącznie po uzyskaniu uprzedniej zgody Użytkownika, jeżeli przepisy prawa tego wymagają.
              </li>
              <li>
                Użytkownik może zarządzać ustawieniami cookies za pośrednictwem banera cookies lub ustawień przeglądarki internetowej.
              </li>
              <li>
                Ograniczenie stosowania cookies może wpłynąć na niektóre funkcjonalności Sklepu.
              </li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
              <span className="text-green-600 dark:text-green-400 font-bold mr-3">§9</span>
              Bezpieczeństwo danych
            </h2>
            <ol className="list-decimal list-outside ml-6 space-y-3">
              <li>
                Administrator stosuje odpowiednie środki techniczne i organizacyjne w celu ochrony danych osobowych przed ich utratą, zniszczeniem, nieuprawnionym ujawnieniem lub dostępem.
              </li>
              <li>
                Sklep korzysta z szyfrowania połączenia SSL/TLS.
              </li>
              <li>
                Dane płatnicze są obsługiwane przez zewnętrznego operatora płatności. Administrator nie przechowuje pełnych danych kart płatniczych na własnych serwerach.
              </li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
              <span className="text-green-600 dark:text-green-400 font-bold mr-3">§10</span>
              Zmiany Polityki Prywatności
            </h2>
            <ol className="list-decimal list-outside ml-6 space-y-3">
              <li>
                Administrator może wprowadzać zmiany do niniejszej Polityki Prywatności, w szczególności w przypadku zmian przepisów prawa, technologii lub sposobu działania Sklepu.
              </li>
              <li>
                Aktualna wersja Polityki Prywatności jest zawsze dostępna na stronie Sklepu.
              </li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
              <span className="text-green-600 dark:text-green-400 font-bold mr-3">§11</span>
              Postanowienia końcowe
            </h2>
            <ol className="list-decimal list-outside ml-6 space-y-3">
              <li>
                W sprawach nieuregulowanych niniejszą Polityką Prywatności zastosowanie mają przepisy RODO oraz właściwe przepisy prawa polskiego.
              </li>
              <li>
                Polityka Prywatności obowiązuje od dnia 1 stycznia 2025 r.
              </li>
            </ol>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-200 dark:border-gray-700">
          <div className="text-sm text-gray-500 dark:text-gray-400 space-y-1">
            <p className="font-semibold text-gray-700 dark:text-gray-300">MERCATUS IT Michał Mierzejewski</p>
            <p>Białogórne 5, 96-230 Białogórne</p>
            <p>NIP: 8351621513</p>
            <p>Email: iglakmierz@gmail.com</p>
          </div>
        </div>
      </div>
    </div>
  );
}
